import styled from 'styled-components';
import ds, { media } from 'designsystem';
import { bigImageWidth, mediumImageWidth, smallImageWidth } from 'common/consts/person-image';

const ImageColumn = styled.div`
  display: block;
  flex-direction: column;
  margin-right: ${ds.get('metrics.s')};
  width: ${smallImageWidth};

  ${media.mobile`
    display: inline-block;
  `};
    
  ${media.tablet`
    width: ${mediumImageWidth};
    display: inline-block;
  `};
  
  ${media.desktop`
    width: ${bigImageWidth};
    margin-right: ${ds.get('metrics.l')};
  `}
`;

export default ImageColumn;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/ImageColumn.jsx